// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_angular_fire_node_modules_firebase_compat_messaging_dist_esm_index_esm_js":"dd0c5cefbb86287d","node_modules_dompurify_dist_purify_js":"c1b8bdb944b9dbef","node_modules_canvg_lib_index_es_js":"7e3d38c4531b8623"}[chunkId] + ".js";
};